import get from 'lodash/get';
import prestoTracker from 'src/modules/presto-tracker/prestoTrackerCreator';

const createPrestoLoggingMiddleware = () => store => next => ({
  meta,
  ...restActionProperties
}) => {
  const { user } = store.getState();
  const result = next({ meta, ...restActionProperties });

  if (meta && meta.prestoLogging) {
    const lastKnownSearchToken = get(
      store.getState(),
      'results.uniqueSearchToken'
    );
    const {
      type = 'log2',
      data,
      ...restPrestoLoggingProperties
    } = meta.prestoLogging;
    const loggingArguments = {
      type,
      data: {
        ...data,
        ...restPrestoLoggingProperties,
        lastKnownSearchToken,
        sessionId: user ? user.sessionId : ''
      }
    };
    prestoTracker({ ...loggingArguments });
  }

  return result;
};

export default createPrestoLoggingMiddleware;
